import React from 'react';
import {ConnectedRouter} from 'connected-react-router';
import {history} from 'app/store';
import {Redirect, Route, Switch} from 'react-router';
import AuthorizeRoute from 'features/auth/AuthorizeRoute';
import {ApplicationAuthPaths} from 'features/auth/authContstants';
import * as appRoutes from 'app/appRoutes';
import AuthHandlerRoutes from 'features/auth/AuthHandlerRoutes';
import Layout from './Layout';
import SelectFilterPage from 'features/selectFilter/SelectFilterPage';
import ImageListPage from 'features/imageList/ImageListPage';
import FileUploadPage from 'features/fileUpload/FileUploadPage';
import UserManagementPage from 'features/userManagement/UserManagementPage';


export default function Routes(props: any) {
    return  <ConnectedRouter history={history}>
        <Layout>
            <Switch>
                <Route path={ApplicationAuthPaths.ApiAuthorizationPrefix} component={AuthHandlerRoutes} />
                <AuthorizeRoute path={appRoutes.rootPath} exact component={SelectFilterPage} />
                <AuthorizeRoute path={appRoutes.imagesPath} exact component={ImageListPage} />
                <AuthorizeRoute path={appRoutes.uploadPath} exact component={FileUploadPage} />
                <AuthorizeRoute path={appRoutes.userManagementPath} exact component={UserManagementPage} />
                <Redirect to={appRoutes.rootPath} />
            </Switch>
        </Layout>
    </ConnectedRouter>;
}